<div class="bo-backdrop" *ngIf="open" (click)="onBackdropClick($event)">
  <section
    class="bo-modal"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="categoryName + ' payment details'"
  >
    <!-- <div
      class="bo-payment-processing-layer"
      *ngIf="paymentProcessing"
      role="status"
      aria-live="polite"
    >
      <div class="bo-payment-processing-card">
        <div class="bo-payment-processing-spinner"></div>
        <h4>Connecting to Razorpay</h4>
        <p>{{ paymentStatusMessage || "Preparing secure payment" }}</p>
        <small>Please do not close or refresh this page.</small>
      </div>
    </div> -->
<div
  class="bo-payment-processing-layer"
  *ngIf="paymentProcessing"
  role="status"
  aria-live="polite"
>
  <div class="bo-payment-processing-card">
    <div
      class="bo-payment-processing-spinner"
    ></div>

    <h4>Connecting to Razorpay</h4>

    <p>
      {{
        paymentStatusMessage ||
        "Preparing secure payment"
      }}
    </p>

    <!-- 10-minute timer -->
    <div
      *ngIf="shouldShowPaymentTimer"
      class="bo-payment-countdown"
      [class.bo-payment-countdown-expired]="
        paymentTimerExpired
      "
    >
      <div class="bo-payment-countdown-label">
        <i class="fa-regular fa-clock"></i>

        <span>
          {{
            paymentTimerExpired
              ? "Payment time expired"
              : "Complete payment within"
          }}
        </span>
      </div>

      <strong class="bo-payment-countdown-time">
        {{ paymentTimerText }}
      </strong>
    </div>

    <small>
      Please do not close or refresh this page.
    </small>
  </div>
</div>
    <aside class="bo-side">
      <div
        class="bo-service-icon"
        [style.background]="
          category?.gradient || 'linear-gradient(135deg, #ff7a18, #af002d)'
        "
      >
        <i [class]="category?.icon || 'fa-solid fa-receipt'"></i>
      </div>

      <p class="bo-eyebrow">Nishwik BBPS</p>
      <h2>{{ categoryName }}</h2>
      <p class="bo-description">
        {{ categoryDescription }}
      </p>

      <div
        class="bo-steps"
        [class.history-muted]="transactionHistoryOpen"
      >
        <div
          class="bo-step"
          [class.active]="step === 'customer-details'"
          [class.completed]="step === 'review'"
        >
          <span class="bo-step-number">
            <i
              class="fa-solid fa-check"
              *ngIf="step === 'review'"
            ></i>

            <ng-container *ngIf="step === 'customer-details'">
              1
            </ng-container>
          </span>

          <div>
            <strong>
              {{
                usesExternalProviderList
                  ? "Provider & customer details"
                  : "Customer details"
              }}
            </strong>
            <small>
              {{
                usesExternalProviderList
                  ? "Select provider and enter details"
                  : "Enter required information"
              }}
            </small>
          </div>
        </div>

        <div
          class="bo-step"
          [class.active]="step === 'review'"
          [class.completed]="paymentSuccess"
        >
          <span class="bo-step-number">
            <i
              class="fa-solid fa-check"
              *ngIf="paymentSuccess"
            ></i>

            <ng-container *ngIf="!paymentSuccess">
              2
            </ng-container>
          </span>

          <div>
            <strong>
              {{ supportsPlanSelection ? "Select Plan" : "Bill details" }}
            </strong>

            <small>
              {{
                supportsPlanSelection
                  ? "Choose plan and pay securely"
                  : "Review bill and pay securely"
              }}
            </small>
          </div>
        </div>
      </div>

      <button
        type="button"
        class="bo-transaction-history-nav"
        *ngIf="supportsPlanSelection"
        [class.active]="transactionHistoryOpen"
        (click)="openTransactionHistory()"
      >
        <span class="bo-transaction-history-nav-icon">
          <i class="fa-solid fa-clock-rotate-left"></i>
        </span>

        <span class="bo-transaction-history-nav-copy">
          <strong>Transaction History</strong>
          <small>Recharge amount, time and status</small>
        </span>

        <i class="fa-solid fa-chevron-right"></i>
      </button>

      <div class="bo-secure-note">
        <i class="fa-solid fa-shield-halved"></i>
        <span>Secure and encrypted payment flow</span>
      </div>
    </aside>

    <main class="bo-main">
      <header class="bo-header">
        <div>
          <p>
            {{
              transactionHistoryOpen
                ? "Your recent recharge activity"
                : step === "customer-details"
                  ? isProviderSelectionStage
                    ? "Choose your service provider"
                    : "Let’s get your payment done"
                  : supportsPlanSelection
                    ? "Choose a recharge plan"
                    : "Review your fetched bill"
            }}
          </p>

          <h3>
            {{
              transactionHistoryOpen
                ? "Transaction History"
                : step === "customer-details"
                  ? isProviderSelectionStage
                    ? "Select Provider"
                    : categoryName + " Details"
                  : supportsPlanSelection
                    ? "Select Plan"
                    : "Bill Details & Amount"
            }}
          </h3>
        </div>

        <button
          type="button"
          class="bo-mobile-history-button"
          *ngIf="supportsPlanSelection && !transactionHistoryOpen"
          aria-label="Open transaction history"
          (click)="openTransactionHistory()"
        >
          <i class="fa-solid fa-clock-rotate-left"></i>
        </button>

        <button
          type="button"
          class="bo-close"
          aria-label="Close popup"
          [disabled]="paymentProcessing"
          (click)="closePopup()"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </header>

      <div class="bo-content">
        <section
          class="bo-transaction-history-view"
          *ngIf="transactionHistoryOpen"
        >
          <div class="bo-transaction-history-toolbar">
            <div>
              <span>API-backed recharge records</span>
              <strong>
                {{ transactionHistory.length }} transactions
              </strong>
            </div>

            <div class="bo-transaction-history-toolbar-actions">
              <button
                type="button"
                class="bo-transaction-history-refresh"
                [disabled]="transactionHistoryLoading"
                (click)="refreshTransactionHistory()"
              >
                <i
                  [class]="
                    transactionHistoryLoading
                      ? 'fa-solid fa-spinner fa-spin'
                      : 'fa-solid fa-rotate-right'
                  "
                ></i>
                Refresh
              </button>

              <button
                type="button"
                class="bo-transaction-history-back"
                (click)="closeTransactionHistory()"
              >
                <i class="fa-solid fa-arrow-left"></i>
                Back to recharge
              </button>
            </div>
          </div>

          <div
            class="bo-transaction-history-loading"
            *ngIf="transactionHistoryLoading"
          >
            <span class="bo-inline-spinner"></span>
            <span>Loading transaction history...</span>
          </div>

          <div
            class="bo-transaction-history-message"
            *ngIf="
              !transactionHistoryLoading &&
              transactionHistoryMessage
            "
          >
            <i class="fa-solid fa-circle-info"></i>
            <span>{{ transactionHistoryMessage }}</span>
          </div>

          <div
            class="bo-transaction-history-list"
            *ngIf="
              !transactionHistoryLoading &&
              transactionHistory.length > 0
            "
          >
            <article
              class="bo-transaction-history-card"
              *ngFor="
                let transaction of transactionHistory;
                trackBy: trackByTransactionHistoryId
              "
            >
              <div
                class="bo-transaction-history-status-icon"
                [class.success]="
                  transaction.statusKind === 'success'
                "
                [class.failed]="
                  transaction.statusKind === 'failed'
                "
                [class.cancelled]="
                  transaction.statusKind === 'cancelled'
                "
                [class.processing]="
                  transaction.statusKind === 'processing'
                "
              >
                <i
                  [class]="
                    getTransactionHistoryStatusIcon(transaction)
                  "
                ></i>
              </div>

              <div class="bo-transaction-history-main">
                <div class="bo-transaction-history-heading">
                  <div>
                    <strong>
                      {{ transaction.operatorName || 'Recharge' }}
                    </strong>
                    <span>
                      {{
                        transaction.mobileNumber ||
                          'Mobile number unavailable'
                      }}
                    </span>
                  </div>

                  <strong class="bo-transaction-history-amount">
                    ₹{{ transaction.amount | number: "1.2-2" }}
                  </strong>
                </div>

                <div class="bo-transaction-history-meta">
                  <span>
                    <i class="fa-regular fa-clock"></i>
                    {{
                      getTransactionHistoryDisplayTime(
                        transaction.transactionDate
                      )
                    }}
                  </span>

                  <span
                    class="bo-transaction-history-status"
                    [class.success]="
                      transaction.statusKind === 'success'
                    "
                    [class.failed]="
                      transaction.statusKind === 'failed'
                    "
                    [class.cancelled]="
                      transaction.statusKind === 'cancelled'
                    "
                    [class.processing]="
                      transaction.statusKind === 'processing'
                    "
                  >
                    {{ transaction.status }}
                  </span>
                </div>

                <div
                  class="bo-transaction-history-reference"
                  *ngIf="
                    transaction.rechargeId ||
                    transaction.orderId ||
                    transaction.prrn
                  "
                >
                  <span *ngIf="transaction.rechargeId">
                    Recharge ID: {{ transaction.rechargeId }}
                  </span>
                  <span *ngIf="transaction.orderId">
                    Order ID: {{ transaction.orderId }}
                  </span>
                  <span *ngIf="transaction.prrn">
                    PRRN: {{ transaction.prrn }}
                  </span>
                </div>
              </div>
            </article>
          </div>
        </section>

        <div
          class="bo-loading"
          *ngIf="loading && !transactionHistoryOpen"
        >
          <div class="bo-spinner"></div>
          <h4>{{ loadingMessage }}</h4>
          <p>Please wait for a moment.</p>
        </div>

        <ng-container *ngIf="!loading && !transactionHistoryOpen">
          <div class="bo-alert" *ngIf="errorMessage">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>{{ errorMessage }}</span>
          </div>

          <div class="bo-information" *ngIf="informationMessage">
            <i class="fa-solid fa-circle-info"></i>
            <span>{{ informationMessage }}</span>
          </div>

          <!-- Customer details -->
          <section
            *ngIf="step === 'customer-details'"
          >
            <!-- Provider-first stage for electricity, gas,
                 water, broadband, DTH, insurance, EMI,
                 FASTag and other BBPS categories. -->
            <ng-container
              *ngIf="
                usesExternalProviderList &&
                providerStage === 'provider-list'
              "
            >
              <div class="bo-provider-browser">
                <div class="bo-provider-browser-head">
                  <div>
                    <span class="bo-provider-kicker">
                      {{ categoryName }}
                    </span>

                    <h4>All Providers</h4>

                    <p>
                      Select your service provider to
                      continue with customer details.
                    </p>
                  </div>

                  <span class="bo-provider-count">
                    {{ filteredProviders.length }}
                    providers
                  </span>
                </div>

                <div class="bo-provider-search">
                  <i
                    class="fa-solid fa-magnifying-glass"
                  ></i>

                  <input
                    type="text"
                    placeholder="Search provider..."
                    [(ngModel)]="providerSearch"
                    [ngModelOptions]="{
                      standalone: true,
                    }"
                    autocomplete="off"
                  />

                  <button
                    type="button"
                    *ngIf="providerSearch"
                    aria-label="Clear provider search"
                    (click)="providerSearch = ''"
                  >
                    <i
                      class="fa-solid fa-xmark"
                    ></i>
                  </button>
                </div>

                <div
                  class="bo-provider-loading"
                  *ngIf="providerLoading"
                >
                  <span
                    class="bo-inline-spinner"
                  ></span>

                  <span>
                    Loading service providers...
                  </span>
                </div>

                <div
                  class="bo-provider-grid"
                  *ngIf="
                    !providerLoading &&
                    filteredProviders.length > 0
                  "
                >
                  <button
                    type="button"
                    class="bo-provider-card"
                    *ngFor="
                      let provider of filteredProviders;
                      trackBy: trackByProviderCode
                    "
                    [class.selected]="
                      selectedProviderCode ===
                      provider.code
                    "
                    (click)="selectProvider(provider)"
                  >
                    <span
                      class="bo-provider-card-logo"
                    >
                      <img
                        *ngIf="provider.logo"
                        [src]="provider.logo"
                        [alt]="provider.name"
                      />

                      <i
                        *ngIf="!provider.logo"
                        [class]="
                          category?.icon ||
                          'fa-solid fa-building'
                        "
                      ></i>
                    </span>

                    <span
                      class="bo-provider-card-copy"
                    >
                      <strong>
                        {{ provider.name }}
                      </strong>

                      <small
                        *ngIf="provider.code"
                      >
                        {{ provider.code }}
                      </small>
                    </span>

                    <i
                      class="fa-solid fa-chevron-right bo-provider-arrow"
                    ></i>
                  </button>
                </div>

                <div
                  class="bo-provider-empty"
                  *ngIf="
                    !providerLoading &&
                    providerList.length > 0 &&
                    filteredProviders.length === 0
                  "
                >
                  <i
                    class="fa-regular fa-folder-open"
                  ></i>

                  <strong>
                    No matching provider found
                  </strong>

                  <span>
                    Try another provider name or code.
                  </span>
                </div>

                <div
                  class="bo-provider-empty"
                  *ngIf="
                    !providerLoading &&
                    providerList.length === 0
                  "
                >
                  <i
                    class="fa-solid fa-building-circle-exclamation"
                  ></i>

                  <strong>
                    No providers available
                  </strong>

                  <span>
                    Retry after verifying the GetOperators
                    response for this category.
                  </span>

                  <button
                    type="button"
                    class="bo-provider-retry"
                    (click)="loadProvidersForCategory()"
                  >
                    <i
                      class="fa-solid fa-rotate-right"
                    ></i>
                    Retry
                  </button>
                </div>
              </div>
            </ng-container>

            <!-- Existing customer-details flow. Mobile recharge
                 enters here directly. Other categories enter
                 here after selecting a provider. -->
            <ng-container
              *ngIf="
                !usesExternalProviderList ||
                providerStage === 'customer-form'
              "
            >
              <div
                class="bo-selected-provider-card"
                *ngIf="
                  usesExternalProviderList &&
                  selectedProvider
                "
              >
                <div
                  class="bo-selected-provider-logo"
                >
                  <img
                    *ngIf="selectedProvider?.logo"
                    [src]="selectedProvider?.logo"
                    [alt]="selectedProvider?.name"
                  />

                  <i
                    *ngIf="!selectedProvider?.logo"
                    [class]="
                      category?.icon ||
                      'fa-solid fa-building'
                    "
                  ></i>
                </div>

                <div
                  class="bo-selected-provider-copy"
                >
                  <span>Selected provider</span>

                  <strong>
                    {{ selectedProvider?.name }}
                  </strong>

                  <small
                    *ngIf="selectedProvider?.code"
                  >
                    {{ selectedProvider?.code }}
                  </small>
                </div>

                <button
                  type="button"
                  (click)="editSelectedProvider()"
                >
                  Edit
                </button>
              </div>

              <div
                class="bo-service-summary"
                *ngIf="!usesExternalProviderList"
              >
                <div
                  class="bo-summary-icon"
                  [style.background]="
                    category?.gradient ||
                    'linear-gradient(135deg, #ff7a18, #af002d)'
                  "
                >
                  <i
                    [class]="
                      category?.icon ||
                      'fa-solid fa-receipt'
                    "
                  ></i>
                </div>

                <div>
                  <strong>{{ categoryName }}</strong>
                  <span>
                    {{ categoryDescription }}
                  </span>
                </div>
              </div>

              <div class="bo-form-grid">
                <div
                  class="bo-form-group"
                  *ngFor="
                    let field of fields;
                    trackBy: trackByFieldKey
                  "
                >
                  <label>
                    {{ field.label }}

                    <span *ngIf="field.required">
                      *
                    </span>
                  </label>

                  <div
                    class="bo-input"
                    [class.invalid]="
                      getFieldError(field)
                    "
                  >
                    <i
                      [class]="
                        getInputIcon(field)
                      "
                    ></i>

                    <input
                      [(ngModel)]="
                        formData[field.key]
                      "
                      [ngModelOptions]="{
                        standalone: true,
                      }"
                      [type]="field.type"
                      [placeholder]="
                        field.placeholder
                      "
                      [attr.minlength]="
                        field.minLength || null
                      "
                      [attr.maxlength]="
                        field.maxLength || null
                      "
                      [attr.inputmode]="
                        field.type === 'tel'
                          ? 'numeric'
                          : null
                      "
                      autocomplete="off"
                    />
                  </div>

                  <small
                    class="bo-field-error"
                    *ngIf="getFieldError(field)"
                  >
                    {{ getFieldError(field) }}
                  </small>
                </div>
              </div>

              <div class="bo-info-note">
                <i
                  class="fa-solid fa-circle-info"
                ></i>

                <span>
                  {{
                    isOperatorLookupRequired
                      ? "The operator and circle will be detected automatically from the entered number."
                      : "The selected provider API will be used to fetch the bill. Manual amount entry remains available if bill fetch is unavailable."
                  }}
                </span>
              </div>
            </ng-container>
          </section>

          <!-- Prepaid plan selection -->
          <section *ngIf="step === 'review' && supportsPlanSelection">
            <div class="bo-operator-card" *ngIf="operatorDetails">
              <div class="bo-operator-logo">
                <i class="fa-solid fa-sim-card"></i>
              </div>

              <div class="bo-operator-copy">
                <span>Detected operator</span>

                <strong>
                  {{ operatorDetails.operatorName }}
                </strong>

                <small>
                  {{ mobileNumber }}

                  <ng-container *ngIf="operatorDetails.circleName">
                    &nbsp;•&nbsp;
                    {{ operatorDetails.circleName }}
                  </ng-container>
                </small>
              </div>

              <button type="button" (click)="goBack()">Edit</button>
            </div>

            <div class="bo-plan-toolbar" *ngIf="prepaidPlans.length > 0">
              <div class="bo-plan-search">
                <i class="fa-solid fa-magnifying-glass"></i>

                <input
                  type="text"
                  placeholder="Search recharge plan"
                  [(ngModel)]="planSearch"
                  [ngModelOptions]="{
                    standalone: true,
                  }"
                />
              </div>
            </div>

            <div class="bo-plan-tabs" *ngIf="planCategories.length > 0">
              <button
                type="button"
                *ngFor="let planCategory of planCategories"
                [class.active]="selectedPlanCategory === planCategory"
                (click)="selectedPlanCategory = planCategory"
              >
                {{ planCategory }}
              </button>
            </div>

            <div class="bo-plan-list" *ngIf="filteredPlans.length > 0">
              <article
                class="bo-plan-card"
                *ngFor="let plan of filteredPlans; trackBy: trackByPlanId"
                [class.selected]="selectedPlan?.id === plan.id"
                (click)="selectPlan(plan)"
              >
                <div
                  class="bo-plan-popular"
                  *ngIf="plan.category === 'Recommended'"
                >
                  Popular
                </div>

                <div class="bo-plan-main">
                  <strong class="bo-plan-amount"> ₹{{ plan.amount }} </strong>

                  <div class="bo-plan-feature">
                    <span>Validity</span>
                    <strong>{{ plan.validity }}</strong>
                  </div>

                  <div class="bo-plan-feature">
                    <span>Data / Benefit</span>
                    <strong>
                      {{ plan.dataBenefit }}
                    </strong>
                  </div>

                  <button
                    type="button"
                    class="bo-plan-apply"
                    (click)="selectPlan(plan); $event.stopPropagation()"
                  >
                    {{ selectedPlan?.id === plan.id ? "Selected" : "Apply" }}
                  </button>
                </div>

                <div
                  class="bo-plan-description"
                  *ngIf="
                    plan.description || plan.talkTime || getPlanCostPerDay(plan)
                  "
                >
                  <span *ngIf="plan.description">
                    {{ plan.description }}
                  </span>

                  <span *ngIf="plan.talkTime">
                    Talktime: {{ plan.talkTime }}
                  </span>

                  <span
                    class="bo-cost-per-day"
                    *ngIf="getPlanCostPerDay(plan) as costPerDay"
                  >
                    Cost/day: ₹{{ costPerDay | number: "1.1-1" }}
                  </span>
                </div>
              </article>
            </div>

            <div
              class="bo-no-plans"
              *ngIf="prepaidPlans.length > 0 && filteredPlans.length === 0"
            >
              <i class="fa-regular fa-folder-open"></i>
              <strong>No matching plans found</strong>
              <span> Try another category or plan. </span>
            </div>

          </section>

          <!-- Existing non-prepaid review -->
          <section *ngIf="step === 'review' && !supportsPlanSelection">
            <div class="bo-operator-card" *ngIf="operatorDetails">
              <div class="bo-operator-logo">
                <i class="fa-solid fa-sim-card"></i>
              </div>

              <div class="bo-operator-copy">
                <span>Detected operator</span>
                <strong>
                  {{ operatorDetails.operatorName }}
                </strong>

                <small>
                  {{ mobileNumber }}

                  <ng-container *ngIf="operatorDetails.circleName">
                    &nbsp;•&nbsp;
                    {{ operatorDetails.circleName }}
                  </ng-container>
                </small>
              </div>

              <button type="button" (click)="goBack()">Edit</button>
            </div>

            <div class="bo-operator-card" *ngIf="selectedProvider">
              <div class="bo-operator-logo bo-provider-logo">
                <i class="fa-solid fa-building"></i>
              </div>

              <div class="bo-operator-copy">
                <span>Selected provider</span>
                <strong>
                  {{ selectedProvider?.name }}
                </strong>
                <small>
                  {{ selectedProvider?.code }}
                </small>
              </div>

              <button type="button" (click)="goBack()">Edit</button>
            </div>

            <!--
              FetchBill result. The rows are created dynamically from the
              provider response, so Electricity, DTH, Gas, Water, Broadband,
              FASTag, EMI, Insurance and other billers can show their own
              customer-facing fields without hard-coded static values.
            -->
            <div class="bo-review-card" *ngIf="fetchedBill">
              <div class="bo-review-heading">
                <div
                  class="bo-summary-icon"
                  [style.background]="
                    category?.gradient ||
                    'linear-gradient(135deg, #ff7a18, #af002d)'
                  "
                >
                  <i [class]="category?.icon || 'fa-solid fa-receipt'"></i>
                </div>

                <div>
                  <span>Fetched bill details</span>
                  <strong>{{ categoryName }}</strong>
                </div>
              </div>

              <!-- Keep the entered provider-specific customer fields -->
              <div
                class="bo-review-row"
                *ngFor="let field of fields; trackBy: trackByFieldKey"
              >
                <span>{{ field.label }}</span>

                <strong>
                  {{ getDisplayValue(field) }}
                </strong>
              </div>

              <!-- Show every customer-facing field returned by FetchBill -->
              <div
                class="bo-review-row"
                *ngFor="let row of billDetailRows"
              >
                <span>{{ row.label }}</span>
                <strong>{{ row.value }}</strong>
              </div>
            </div>

            <div class="bo-info-note" *ngIf="fetchedBill">
              <i class="fa-solid fa-circle-check"></i>
              <span>
                Bill details were fetched from the selected provider. Review
                the information and continue to secure Razorpay payment.
              </span>
            </div>

            <div class="bo-amount-card">
              <div>
                <label>
                  {{
                    fetchedBill && fetchedBill.amount > 0
                      ? "Payable Amount"
                      : "Bill Details & Amount"
                  }}
                </label>

                <small>
                  {{
                    fetchedBill && fetchedBill.amount > 0
                      ? "Amount received from the FetchBill API"
                      : "The provider did not return an amount. Enter the amount to continue."
                  }}
                </small>
              </div>

              <div class="bo-amount-input">
                <span>₹</span>

                <input
                  type="number"
                  min="1"
                  step="0.01"
                  placeholder="0.00"
                  [ngModel]="amount"
                  (ngModelChange)="onAmountChanged($event)"
                  [readonly]="!!fetchedBill && fetchedBill.amount > 0"
                  [ngModelOptions]="{
                    standalone: true,
                  }"
                />
              </div>
            </div>
          </section>


        </ng-container>
      </div>

      <footer class="bo-footer" *ngIf="!loading && !transactionHistoryOpen">
        <button
          type="button"
          class="bo-secondary"
          *ngIf="
            step !== 'customer-details' ||
            isProviderCustomerFormStage
          "
          [disabled]="paymentProcessing"
          (click)="goBack()"
        >
          <i class="fa-solid fa-arrow-left"></i>
          Back
        </button>
        <span class="bo-footer-spacer"></span>

        <button
          type="button"
          class="bo-primary"
          *ngIf="
            step === 'customer-details' &&
            (
              !usesExternalProviderList ||
              providerStage === 'customer-form'
            )
          "
          [disabled]="providerLoading"
          (click)="submitCustomerDetails()"
        >
          Next
          <i class="fa-solid fa-arrow-right"></i>
        </button>

        <button
          type="button"
          class="bo-primary"
          *ngIf="step === 'review'"
          [disabled]="
            (supportsPlanSelection && !selectedPlan) ||
            currentAmount <= 0 ||
            paymentProcessing ||
            paymentSuccess
          "
          (click)="openDirectRazorpayCheckout()"
        >
          <ng-container *ngIf="!paymentProcessing && !paymentSuccess">
            Pay ₹{{ currentAmount | number: "1.2-2" }} with Razorpay
            <i class="fa-solid fa-shield-halved"></i>
          </ng-container>

          <ng-container *ngIf="paymentProcessing">
            <i class="fa-solid fa-spinner fa-spin"></i>
            Opening Razorpay…
          </ng-container>

          <ng-container *ngIf="paymentSuccess">
            <i class="fa-solid fa-circle-check"></i>
            Payment Successful
          </ng-container>
        </button>


      </footer>
    </main>
  </section>
</div>

<!-- Payment Failure Dialog -->
<div
  class="payment-failure-overlay"
*ngIf="
  showPaymentFailureDialog &&
  paymentFailureDialogData
"
  (click)="
    paymentDialogMode === 'failure'
      ? closePaymentFailureDialog()
      : null
  "
>
  <section
    class="payment-failure-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="paymentFailureTitle"
    (click)="$event.stopPropagation()"
  >
    <!-- Failure screen -->
    <ng-container *ngIf="!queryRaised">
<div
  class="payment-failure-icon"
  [class.payment-success-icon]="
    paymentDialogMode === 'success'
  "
>
  <i
    *ngIf="
      paymentDialogMode === 'failure'
    "
    class="fa-solid fa-circle-xmark"
  ></i>

  <i
    *ngIf="
      paymentDialogMode === 'success'
    "
    class="fa-solid fa-circle-check"
  ></i>
</div>

      <div class="payment-failure-heading">
<h3 id="paymentFailureTitle">
  {{
    paymentDialogMode === "success"
      ? "Payment Successful"
      : "Payment Failed"
  }}
</h3>

<p>
  {{
    paymentDialogMode === "success"
      ? "Your payment has been completed successfully."
      : "Your payment could not be completed. You may raise a query for this transaction."
  }}
</p>
      </div>

      <!-- Expand/collapse button -->
      <button
        type="button"
        class="payment-details-toggle"
        [attr.aria-expanded]="
          showPaymentFailureDetails
        "
        (click)="
          showPaymentFailureDetails =
            !showPaymentFailureDetails
        "
      >
        <span>
          <i
            class="fa-regular fa-file-lines"
          ></i>

          Payment information
        </span>

        <i
          class="fa-solid"
          [class.fa-chevron-up]="
            showPaymentFailureDetails
          "
          [class.fa-chevron-down]="
            !showPaymentFailureDetails
          "
        ></i>
      </button>

      <!-- Hidden/shown using arrow -->
      <div
        class="payment-failure-details"
        *ngIf="showPaymentFailureDetails"
      >
        <div
          class="payment-detail-row"
          *ngIf="
            paymentFailureDialogData.customerName
          "
        >
          <span>Customer</span>

          <strong>
            {{
              paymentFailureDialogData
                .customerName
            }}
          </strong>
        </div>

        <div
          class="payment-detail-row"
          *ngIf="
            paymentFailureDialogData.mobile
          "
        >
          <span>Mobile</span>

          <strong>
            {{
              paymentFailureDialogData.mobile
            }}
          </strong>
        </div>

        <div
          class="payment-detail-row"
          *ngIf="
            paymentFailureDialogData.email
          "
        >
          <span>Email</span>

          <strong>
            {{
              paymentFailureDialogData.email
            }}
          </strong>
        </div>

        <div class="payment-detail-row">
          <span>Service</span>

          <strong>
            {{
              paymentFailureDialogData
                .serviceName
            }}
          </strong>
        </div>

        <div
          class="payment-detail-row"
          *ngIf="
            paymentFailureDialogData
              .providerName
          "
        >
          <span>Provider</span>

          <strong>
            {{
              paymentFailureDialogData
                .providerName
            }}
          </strong>
        </div>

        <div class="payment-detail-row">
          <span>Biller Type</span>

          <strong>
            {{
              paymentFailureDialogData
                .billerType
            }}
          </strong>
        </div>

        <div
          class="payment-detail-row"
          *ngIf="
            paymentFailureDialogData
              .customerReference
          "
        >
          <span>Customer Reference</span>

          <strong>
            {{
              paymentFailureDialogData
                .customerReference
            }}
          </strong>
        </div>

        <div class="payment-detail-row">
          <span>Amount</span>

          <strong>
            ₹{{
              paymentFailureDialogData.amount
                | number: "1.2-2"
            }}
          </strong>
        </div>

        <div
          class="payment-detail-row"
          *ngIf="
            paymentFailureDialogData
              .referenceId
          "
        >
          <span>Reference ID</span>

          <strong>
            {{
              paymentFailureDialogData
                .referenceId
            }}
          </strong>
        </div>

        <div
          class="payment-detail-row"
          *ngIf="
            paymentFailureDialogData
              .transactionId
          "
        >
          <span>Transaction ID</span>

          <strong>
            {{
              paymentFailureDialogData
                .transactionId
            }}
          </strong>
        </div>

        <div
          class="payment-detail-row"
          *ngIf="
            paymentFailureDialogData.orderId
          "
        >
          <span>Order ID</span>

          <strong>
            {{
              paymentFailureDialogData.orderId
            }}
          </strong>
        </div>

        <div
          class="payment-detail-row"
          *ngIf="
            paymentFailureDialogData.prrn
          "
        >
          <span>PRRN</span>

          <strong>
            {{
              paymentFailureDialogData.prrn
            }}
          </strong>
        </div>

<div
  class="payment-detail-row"
  [class.failure-reason-row]="
    paymentDialogMode === 'failure'
  "
  [class.success-status-row]="
    paymentDialogMode === 'success'
  "
>
  <span>
    {{
      paymentDialogMode === "success"
        ? "Payment Status"
        : "Failure Reason"
    }}
  </span>

  <strong>
    {{
      paymentFailureDialogData
        .failureReason
    }}
  </strong>
</div>
      </div>

      <div
        class="query-error-message"
        *ngIf="queryErrorMessage"
      >
        <i
          class="fa-solid fa-circle-exclamation"
        ></i>

        <span>{{ queryErrorMessage }}</span>
      </div>

<!-- Failed-payment actions -->
<div
  class="payment-failure-actions"
  *ngIf="
    paymentDialogMode === 'failure'
  "
>
  <button
    type="button"
    class="failure-cancel-btn"
    [disabled]="querySubmitting"
    (click)="
      closePaymentFailureDialog()
    "
  >
    Cancel
  </button>

  <button
    type="button"
    class="failure-query-btn"
    [disabled]="querySubmitting"
    (click)="raisePaymentQuery()"
  >
    <i
      *ngIf="querySubmitting"
      class="fa-solid fa-spinner fa-spin"
    ></i>

    <i
      *ngIf="!querySubmitting"
      class="fa-solid fa-headset"
    ></i>

    {{
      querySubmitting
        ? "Raising Query..."
        : "Raise Query"
    }}
  </button>
</div>

<!-- Successful-payment action -->
<div
  class="payment-failure-actions payment-success-actions"
  *ngIf="
    paymentDialogMode === 'success'
  "
>
  <button
    type="button"
    class="failure-query-btn payment-done-btn"
    (click)="
      donePaymentSuccessDialog()
    "
  >
    <i
      class="fa-solid fa-check"
    ></i>

    Done
  </button>
</div>
    </ng-container>

    <!-- Success screen -->
    <div
      class="query-success-content"
      *ngIf="queryRaised"
    >
      <div class="query-success-icon">
        <i
          class="fa-solid fa-circle-check"
        ></i>
      </div>

      <h3>Query Raised Successfully</h3>

      <p>
        Your payment-failure query has been
        submitted to our support team.
      </p>

      <div
        class="created-ticket-number"
        *ngIf="createdQueryTicketNo"
      >
        <span>Ticket Number</span>

        <strong>
          {{ createdQueryTicketNo }}
        </strong>
      </div>

      <button
        type="button"
        class="failure-query-btn done-btn"
        (click)="closePaymentFailureDialog()"
      >
        Done
      </button>
    </div>
  </section>
</div>
